import { CanActivateFn } from '@angular/router';
import { permissionGuard } from './permission.guard';

export const favoritesPermissionGuard: CanActivateFn = permissionGuard('CanReadFavorite');

